import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["container", "backdrop", "dialog"]
  static values = {
    open: { type: Boolean, default: false }
  }

  get modalElement() {
    return this.hasDialogTarget ? this.dialogTarget : this.element
  }

  connect() {
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundCloseOnEscape)
    document.body.style.overflow = ""
  }

  open(event) {
    if (event) {
      event.preventDefault()
    }

    this.openValue = true
    this.modalElement.classList.remove("hidden")

    // Trigger animation
    requestAnimationFrame(() => {
      this.containerTarget.classList.remove("opacity-0", "scale-95")
      this.containerTarget.classList.add("opacity-100", "scale-100")
      this.backdropTarget.classList.remove("opacity-0")
      this.backdropTarget.classList.add("opacity-100")
    })

    // Prevent body scroll
    document.body.style.overflow = "hidden"

    // Add escape key listener
    document.addEventListener("keydown", this.boundCloseOnEscape)

    // Focus first input if available
    const firstInput = this.element.querySelector('input, textarea, select')
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100)
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    this.openValue = false

    // Trigger animation
    this.containerTarget.classList.remove("opacity-100", "scale-100")
    this.containerTarget.classList.add("opacity-0", "scale-95")
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")

    // Hide after animation
    setTimeout(() => {
      this.modalElement.classList.add("hidden")
    }, 200)

    // Restore body scroll
    document.body.style.overflow = ""

    // Remove escape key listener
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget || event.target === this.modalElement) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
